import { StateStorage } from 'zustand/middleware'
import { createStore } from '..'
import { EVMChain } from '../../interfaces/common'

interface EVMChainsInfoState {
  evmChains: EVMChain[]
  setChains: (evmChains: EVMChain[]) => void
  addChain: (evmChain: EVMChain) => void
  removeChain: (chainNum: number) => void
}

export const createEVMChainsInfoStore = (storage: StateStorage) =>
  createStore<EVMChainsInfoState>(
    storage,
    (set, get) => ({
      evmChains: [],
      setChains: (evmChains) => {
        set({ evmChains })
      },
      addChain: (evmChain) => {
        const { evmChains } = get()
        if (!evmChains.some((c) => c.chainId === evmChain.chainId)) {
          set({ evmChains: [...evmChains, evmChain] })
        }
      },
      removeChain: (chainNum) => {
        const { evmChains } = get()
        set({ evmChains: evmChains.filter((c) => c.chainId !== chainNum) })
      },
    }),
    {
      persist: {
        name: 'userEVMChains',
        version: 0,
      },
    }
  )
